import { z } from 'zod';

import { defaultNullish, mongoIdSchema } from './shared';

export enum ProductSectionStatus {
  Ok = 'ok',
  Generating = 'generating',
  GenerationError = 'generationError',
}

export const productSectionCreateSchema = z.object({
  productId: mongoIdSchema,
  templateUniqueId: z.string().nullish(),
  maxNumberOfWords: z.number(),
  allowHeadings: z.boolean(),
  allowLists: z.boolean(),
  guidelinesDocs: z.array(z.string().trim()),
  examplesDocs: z.array(z.string().trim()),
  // body is a stringified tiptap json object
  bodyDoc: z.string().trim(),
  order: z.number(),
  exportName: defaultNullish(z.string().nullish()).default(''),

  status: z.enum([
    ProductSectionStatus.Ok,
    ProductSectionStatus.Generating,
    ProductSectionStatus.GenerationError,
  ]),

  title: z.string().trim(),
});
export type ProductSectionCreate = z.infer<typeof productSectionCreateSchema>;

export const productSectionSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(productSectionCreateSchema);

export type ProductSection = z.infer<typeof productSectionSchema>;
